import React, {useEffect} from 'react';
import Student_form_content from './Student_form_content'
import Student_Form from './Student_Form'
import Student_mobile_form from './Student_mobile_form';

function Student_Register_form() {
  useEffect(()=>{
    document.title= 'Student Register form | InternsElite';
  },[]);
  return (
    <>
    {/* ----------------------Desktop View------------------------- */}
    <div className='background pt-4 pb-5 d-none d-md-block'>
      <div className='container pt-5 mt-5'>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8 shadow px-5 Inner_form_background'>
            <Student_form_content/>
            <Student_Form/>
          </div>
          <div className='col-md-2'></div>
        </div>
      </div>
    </div>

    {/* -------------------Mobile View----------------------- */}
    <div className='background py-4 pb-5 d-sm-block d-md-none'>
      <div className='container'>
          <div className='shadow px-2 Inner_form_background'>
            <Student_form_content/>
            <Student_Form/>
          </div>
      </div>
    </div>
    </>
  )
}

export default Student_Register_form
